import { Component, Injector } from '@angular/core';
import { CoreService } from 'core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  constructor(private injectorObj: Injector) {
    let dataset = this.injectorObj.get(CoreService).appDetails;
    this.buttons[0].handler = dataset.store_url;
    this.buttons[1].handler = dataset.membership_url
    this.buttons[2].handler = dataset.buy_tickets_url
    this.buttons[3].handler = dataset.donation_url
  }
  buttons = [

    { row: 0, IconName: 'store', DisplayName: "Store", handler: "https://www.sdmart.org/store/" },
    { row: 0, IconName: 'id-card', DisplayName: "Join",handler: "https://sdma.ticketapp.org/portal/pages/general_membership"},
    {
      row: 1, IconName: 'ticket', handler: "https://sdma.ticketapp.org/portal/product/23", DisplayName: 'Tickets'
    },
    { row: 1, IconName: 'circle-dollar-to-slot', DisplayName: 'Donate',handler: "https://sdma.ticketapp.org/portal/product/75" }

  ]
}
